export default __webpack_public_path__ + "static/media/kiosk.1fd5316c.png";